module.exports = __webpack_public_path__ + "media/images/application/template/arrow-left-62f5d171d9e629bd46aad645aa80a93f.png";